import React from 'react';
import PropTypes from 'prop-types';
import { LS_ACCESS_TOKEN } from '../../../../../constants';
import WishmakerModal from '../../../../ui/modal/modal';
import { ReportDetailSC, ReportColumnSC } from './report-detail.styled';
import { HeadingTwo, BodyText, SmallText } from '../../../../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../../../utils/default-lang';
import Moment from 'react-moment';
import { ReactComponent as FileIcon } from '../../../../../assets/img/svg/pdf.svg';
import numeral from 'numeral';

const ReportDetail = ({ detail, onClose }) => {
  const onDocumentClick = (docLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${docLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
  };

  function getSign(amount) {
    if (amount < 0) {
      return '-';
    }
    if (amount > 0) {
      return '+';
    }
    return '';
  }

  function toNumber(amount) {
    if (typeof amount === 'string') {
      return Number(amount.replace(' ', '').replace(',', '.'));
    }
    return amount;
  }

  if (!detail) {
    return null;
  }

  const data = JSON.parse(detail.data);
  console.log(data);

  return (
    <WishmakerModal isOpened={!!detail} onClose={() => onClose()} className="report" withCross>
      <ReportDetailSC>
        <div className="top-text-wrap">
          <HeadingTwo className="bold">{detail.subject ? detail.subject : ''}</HeadingTwo>
        </div>
        {/* <div className="greeting">
          <FormattedMessage
            id="mailbox_modal_documents"
            defaultMessage={dlt['mailbox_modal_documents']}
          />
          <span className="greeting--month">
            <Moment format="MMMM">{detail.created_at}</Moment>
          </span>
        </div> */}
        <div className="top-text-wrap--infos">
          <div>
            <BodyText className="bold">
              <FormattedMessage
                id="mailbox_modal_sent"
                defaultMessage={dlt['mailbox_modal_sent']}
              />
            </BodyText>
            <BodyText className="black-transparent">
              <Moment format="DD. MMMM YYYY">{detail.created_at}</Moment>
            </BodyText>
          </div>
          <div>
            <BodyText className="bold">
              <FormattedMessage
                id="mailbox_modal_from"
                defaultMessage={dlt['mailbox_modal_from']}
              />
            </BodyText>
            <BodyText className="black-transparent">{detail.sender}</BodyText>
          </div>
        </div>
        <div className="detail-report">
          <ReportColumnSC type="warn">
            <div className="row">
              <div className="title">
                <FormattedMessage
                  id="mailbox_report_detail_loanStatusOverview_title"
                  defaultMessage={dlt['mailbox_report_detail_loanStatusOverview_title']}
                />
              </div>
              <div className="info">{`${data.loanStatusOverview.paid} : ${data.loanStatusOverview.mediumDelay} : ${data.loanStatusOverview.highDelay}`}</div>
              <div className="foot">
                <FormattedMessage
                  id="mailbox_report_detail_loanStatusOverview_footer"
                  defaultMessage={dlt['mailbox_report_detail_loanStatusOverview_footer']}
                />
              </div>
            </div>
            <div className="row">
              <div className="title">
                <FormattedMessage
                  id="mailbox_report_detail_installmentReceivedNew"
                  defaultMessage={dlt['mailbox_report_detail_installmentReceivedNew']}
                  values={{
                    small: (chunks) => <small className="small">{chunks}</small>,
                  }}
                />
              </div>
              <div className="info">
                {getSign(toNumber(data.installmentReceivedNew))}
                {numeral(toNumber(data.installmentReceivedNew)).format('0,00.00')}
                {` €`}
              </div>
            </div>
            {toNumber(data.investmentNew.count) > 0 && (
              <div className="row">
                <div className="title">
                  <FormattedMessage
                    id="mailbox_report_detail_investmentNew_title"
                    defaultMessage={dlt['mailbox_report_detail_investmentNew_title']}
                    values={{
                      small: (chunks) => <small className="small">{chunks}</small>,
                    }}
                  />
                </div>
                <div className="info">{`${data.investmentNew.count} ks (${numeral(
                  toNumber(data.investmentNew.amount)
                ).format('0,00.00')} €)`}</div>
              </div>
            )}
            <div className="row">
              <div className="title">
                <FormattedMessage
                  id="mailbox_report_detail_evaluationMonthly"
                  defaultMessage={dlt['mailbox_report_detail_evaluationMonthly']}
                  values={{
                    small: (chunks) => <small className="small">{chunks}</small>,
                  }}
                />
              </div>
              <div className="info">
                {getSign(toNumber(data.evaluationMonthly.amount))}
                {numeral(toNumber(data.evaluationMonthly.amount)).format('0,00.00')}
                {` € (${getSign(toNumber(data.evaluationMonthly.amount))}${numeral(
                  toNumber(data.evaluationMonthly.percentage)
                ).format('0.00')} %)`}
              </div>
            </div>
          </ReportColumnSC>
          <ReportColumnSC type="info">
            <div className="row">
              <div className="title">
                <FormattedMessage
                  id="mailbox_report_detail_loanStatusOverviewPercentage_title"
                  defaultMessage={dlt['mailbox_report_detail_loanStatusOverviewPercentage_title']}
                />
              </div>
              <div className="info">{`${data.loanStatusOverviewPercentage.paid} % : ${data.loanStatusOverviewPercentage.mediumDelay} % : ${data.loanStatusOverviewPercentage.highDelay} %`}</div>
              <div className="foot">
                <FormattedMessage
                  id="mailbox_report_detail_loanStatusOverviewPercentage_footer"
                  defaultMessage={dlt['mailbox_report_detail_loanStatusOverviewPercentage_footer']}
                />
              </div>
            </div>
            <div className="row">
              <div className="title">
                <FormattedMessage
                  id="mailbox_report_detail_installmentReceivedTotal"
                  defaultMessage={dlt['mailbox_report_detail_installmentReceivedTotal']}
                  values={{
                    small: (chunks) => <small className="small">{chunks}</small>,
                  }}
                />
              </div>
              <div className="info">
                {getSign(toNumber(data.installmentReceivedTotal))}
                {numeral(toNumber(data.installmentReceivedTotal)).format('0,00.00')}
                {` €`}
              </div>
            </div>
            {toNumber(data.investmentNew.count) > 0 && (
              <div className="row">
                <div className="title">
                  <FormattedMessage
                    id="mailbox_report_detail_investmentTotal_title"
                    defaultMessage={dlt['mailbox_report_detail_investmentTotal_title']}
                    values={{
                      small: (chunks) => <small className="small">{chunks}</small>,
                    }}
                  />
                </div>
                <div className="info">{`${data.investmentTotal.count} ks (${numeral(
                  toNumber(data.investmentTotal.amount)
                ).format('0,00.00')} €)`}</div>
              </div>
            )}
            <div className="row">
              <div className="title">
                <FormattedMessage
                  id="mailbox_report_detail_evaluationTotal_title"
                  defaultMessage={dlt['mailbox_report_detail_evaluationTotal_title']}
                  values={{
                    small: (chunks) => <small className="small">{chunks}</small>,
                  }}
                />
              </div>
              <div className="info">
                {getSign(toNumber(data.evaluationTotal.amount))}
                {numeral(toNumber(data.evaluationTotal.amount)).format('0,00.00')}
                {` € (${getSign(toNumber(data.evaluationTotal.amount))}${numeral(
                  toNumber(data.evaluationTotal.percentage)
                ).format('0.00')} %)`}
              </div>
            </div>
          </ReportColumnSC>
        </div>
        {detail.documents && detail.documents.length > 0 ? (
          <div className="documents-wrap">
            <BodyText className="bold">
              <FormattedMessage
                id="mailbox_modal_documents"
                defaultMessage={dlt['mailbox_modal_documents']}
              />
            </BodyText>
            <div className="documents-wrap--items-wrap">
              {detail.documents.map((doc) => {
                return (
                  <button
                    className="document"
                    onClick={() => onDocumentClick(doc.url)}
                    key={doc.url}
                  >
                    <FileIcon />
                    <SmallText>{doc.name}</SmallText>
                  </button>
                );
              })}
            </div>
          </div>
        ) : null}
      </ReportDetailSC>
    </WishmakerModal>
  );
};

ReportDetail.propTypes = {
  detail: PropTypes.shape({}),
};

export default React.memo(ReportDetail);
